import { render } from "./KappPostsList.vue?vue&type=template&id=1ad7b84e&scoped=true"
import script from "./KappPostsList.vue?vue&type=script&lang=js"
export * from "./KappPostsList.vue?vue&type=script&lang=js"

import "./KappPostsList.vue?vue&type=style&index=0&id=1ad7b84e&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad7b84e"]])

export default __exports__